import axios from 'axios';
import {useQuery} from '@tanstack/react-query';

import {Keys} from 'client/api/_keys';
import {Routes} from 'client/api/_routes';

const aboutUs = async () => axios.get(Routes.ABOUT_US);

export const useAboutUs = () =>
  useQuery({
    queryKey: [Keys.ABOUT_US_QRY],
    queryFn: aboutUs,
  });
